import * as type from '../actions/types';
import { safeParse } from '../utils/helpers';

const initialState = {
  data: {},
  fetching: false,
  error: false,
  errorMessage: '',
  success: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case type.FETCH_POS_STATUS_PENDING: {
      return {
        ...state,
        data: {},
        fetching: true,
        error: false,
        errorMessage: '',
        success: false,
      };
    }
    case type.FETCH_POS_STATUS_SUCCESS: {
      const { data } = action.payload;
      const dataParsed = safeParse(data, {});

      return {
        ...state,
        data: dataParsed,
        fetching: false,
        error: false,
        errorMessage: '',
        success: true,
      };
    }
    case type.FETCH_POS_STATUS_FAILURE: {
      return {
        ...state,
        fetching: false,
        error: true,
        errorMessage: action.payload,
        success: false,
      };
    }
    default: {
      return state;
    }
  }
};
